import { http } from 'src/config';
import { URLSVC } from 'src/config/helper/urlService';
import Swal from 'sweetalert2'
import { loadingBar } from '../globalAction';

export const setGaleris = () => {
    return (dispatch) => {
        http.get(`${URLSVC}/Admins/GaleryGetAll`).then((res) => {
            let data = res.data;
            if (data.IsSuccess) {
                dispatch({type: 'DATA_GALERIS', payload: data.Data})
            } else {
                dispatch({type: 'DATA_GALERIS', payload: data.Data})
                //Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setGaleri = (Id) => {
    return (dispatch) => {
        loadingBar(true);
        dispatch({type: 'RESET_FORM_GALERI'})
        var Url = `${URLSVC}/Admins/GaleryGetById?Id=${Id}`;
        http.get(Url).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                dispatch({ type: 'DATA_GALERI', payload: data.Data })
                dispatch(setFormGaleri('Id', data.Data.Id))
                dispatch(setFormGaleri('Title', data.Data.Title))
                dispatch(setFormGaleri('Description', data.Data.Description))
                dispatch(setFormGaleri('IsSlider', data.Data.IsSlider))
                dispatch(setFormGaleri('IsBanner', data.Data.IsBanner))
                dispatch(setFormGaleri('FileUpload', data.Data.FileUpload))

                dispatch({type: 'MODAL_GALERI', payload: true})
                
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setFormGaleri = (formType, formValue) => {
    return {type: 'FORM_GALERI', formType, formValue}
}

export const apiAddUpdateGaleri = (iData,reset) => {
    return (dispatch) => {
        loadingBar(true);
        var fd = new FormData();
        var URL = ``;
        if(iData.Id == "" || iData.Id == null){
            URL = `${URLSVC}/Admins/GaleryAdd`;
        } else {
            URL = `${URLSVC}/Admins/GaleryEdit`;
        }
        fd.append('Id', iData.Id);
        fd.append('Title', iData.Title);
        fd.append('Description', iData.Description);
        fd.append('IsBanner', iData.IsBanner);
        fd.append('IsSlider', iData.IsSlider);
        iData.FileUpload != undefined && fd.append('FileUpload', iData.FileUpload[0]);
        
        http.post(URL,fd, {timeout:1200000}).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                Swal.fire('Berhasil', `berhasil menyimpan galeri`, 'success');
                dispatch({ type: 'MODAL_GALERI', payload: false })
                reset();
                dispatch(setGaleris())
            } else {
                dispatch({ type: 'MODAL_GALERI', payload: false })
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const apiDeleteGaleri = (Id, Title) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan menghapus data (${Title})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('Id', Id);
                http.post(`${URLSVC}/Admins/GaleryDelete`,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil menghapus data (${Title})`, 'success')
                        dispatch(setGaleris())
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}

export const apiNoApproveGaleri = (Id, Title) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan me-reject data (${Title})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('Id', Id);
                http.post(`${URLSVC}/Admins/GaleryNoApprove`,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil me-reject data (${Title})`, 'success')
                        dispatch(setGaleris())
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}

export const apiApproveGaleri = (Id, Title) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan menyetujui data (${Title})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('Id', Id);
                http.post(`${URLSVC}/Admins/GaleryApprove`,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil menyetujui data (${Title})`, 'success')
                        dispatch(setGaleris())
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}
